<!-- 第三方应用 -->
<template>
  <div class="el-ThirdParty">
    <el-row class="content_block mb20">
      <TitleInfo title="第三方应用" :titleImg="disanf"></TitleInfo>
      <el-row class="pt20 pl20 thirdParty_list">
        <ul>
          <template v-for="(item, index) in myAppsList" >
            <li :key="index" @click="jump(item.studentClientLinkContent)">
              <el-image class="thirdParty_img c_p mr10" :src="$getUrl(item.studentClientLinkImg)"></el-image>
              <el-row>
                <p class="m0 pb10 fontB">{{item.studentClientLinkTitle}}</p>
                <p class="m0 limit_line_four" :title="item.studentClientLinkDesc" style="line-height: 20px;font-size: 13px;" v-html="item.studentClientLinkDesc"></p>
              </el-row>
            </li>
          </template>
        </ul>
      </el-row>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[6, 12, 20, 40]"
          :page-size="limit"
          background
          class="m20 t_r"
          :hide-on-single-page="true"
          layout="sizes, prev, pager, next,jumper"
          :total="total">
        </el-pagination>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
export default {
  name: "ThirdParty",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      disanf:require("../../images/user/disanf@2x.png"),
      myAppsList:[],

      total: 0,
      limit:6,
      page:1,
      timeIn:null
    };
  },
  created() {
    this.getInfo();
    //this.addSystem();
  },
  mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        studentClientLinkType:"THIRD_APPL",
        studentClientLinkStatus:1
      }

      this.$get("/api/studentClientLink/getList.do",param).then((ret)=>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.myAppsList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    jump(item){
      window.open(item);
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"第三方应用",//一级名称
          secondName:"第三方应用",//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-ThirdParty{
    padding: 20px 20px 0;
    .thirdParty_list{
      min-height: 320px;overflow: auto;
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
      }
      li{
        float: left;
        width: calc(33% - 65px);
        padding: 15px;
        margin: 0 20px 20px 0;
        border: 1px solid #E1E1E1;
        cursor: pointer;
        height: 110px;
        border-radius: 10px;
      }
      li:hover{
        border-color: #409EFF;
      }
    }

    .content_block{
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .thirdParty_img{
      width: 180px;
      height: 110px;
      float: left;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/user/ThirdParty.vue